import styled from 'styled-components';

const Scroller = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
`;

export default Scroller;
